import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Status } from '../../common/constants';
import { manageMobileLicenseUsersUrl } from '../../config';
import { RootState } from '../../store';
import { ICreateUser, ICreateUserResponse } from "../../common/types/userTypes";
import api from '../../api';

const MANAGE_MOBILE_LICENSE_USERS: string = "manageMobileLicenseUsers";

export interface IManageMobileLicenseUsersData {
  userIds: string[];
  orgId: string;
}

export interface IManageMobileLicenseUsersResponse {
    status: number;
    message: string;
}

interface IInitialState {
  status: string;
  data: IManageMobileLicenseUsersResponse | null;
  error: string | null | undefined;
}

const initialState: IInitialState = {
  status: Status.IDLE,
  data: null,
  error: null,
};

export const manageMobileLicenseUsers = createAsyncThunk(MANAGE_MOBILE_LICENSE_USERS, async (payload: IManageMobileLicenseUsersData, { rejectWithValue }) => {
  try {
    const response = await api.post<IManageMobileLicenseUsersResponse>(manageMobileLicenseUsersUrl, payload);
    const createUserResponse: IManageMobileLicenseUsersResponse = response.data;
    return createUserResponse;
  } catch (error) {
    throw rejectWithValue(error);
  }
}
);

const manageMobileLicenseUsersSlice = createSlice({
  name: "manageMobileLicenseUsers",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(manageMobileLicenseUsers.pending, (state) => {
        state.status = Status.PENDING;
        state.data = null;
      })
      .addCase(manageMobileLicenseUsers.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = Status.SUCCESS;
      })
      .addCase(manageMobileLicenseUsers.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
      });
  },
});

type Selector = {
    manageMobileLicenseUsersApi: ReturnType<
    typeof manageMobileLicenseUsersSlice.reducer
  >;
};

export const selector = (store: Selector) => store['manageMobileLicenseUsersApi'];

export default manageMobileLicenseUsersSlice.reducer;